import VModal from '@/vuetify_custom/v-modal_v1'
import VTable from '@/vuetify_custom/v-table/v3'
import {formattingNumber} from '@/libs/util';
import { VBtn, VTextField, VTabs, VTab, VIcon} from 'vuetify/lib'
import NumberField from '@/vuetify_custom/v-form/components/Number_Field.js'
import VPage from '@/vuetify_custom/v-pagination'
import Tooltip from '@/views/mine/components/fk_modal/Tooltip.vue'
import {getPlacingAdsRecordSelectSearchApi, postExpenseGroupSavePlacingAdsApi, getPlacingAdsListApi, postExpenseGroupDeletePlacingAdsApi, getPlacingAdsVasRecordSelectSearchApi} from '../service'
import mixIns from './mixIns.jsx'
export default {
  mixins:[mixIns],
  props: {
    tfMax: {
      type: Number
    },
    billType: {
      type: Number
    },
    expenseGroup: {
      type: Object
    },
    isFinancer: {
      type: Boolean
    },
    isCheckSameBill: {
      type: Boolean,
      default: () => false
    },
    havePaidAmountitleTotal: {
      type: String
    }
  },
  data() {
    return {
      show:false,
      params: {
        search: ''
      },
      pre_placingadsrecord_list: [],
      pre_placing_ads_vas_record_list: [],
      placing_ads_records: [],
      placing_ads_vas_records: [],
      get_pre_loading: false,
      get_selected_loading: false,
      tab: 0,
      ads_hash: {},
      tf_page: 1,
      tf_page_size: 10,
      jc_page: 1,
      jc_page_size: 10
    }
  },
  computed: {
   
    page_size_proxy: {
      get() {
          const tab = Number(this.tab)
          return tab === 0 ? this.tf_page_size : this.jc_page_size
      },
      set(v) {
        const tab = Number(this.tab)
          if (tab === 0) {
              this.tf_page_size = v
          } else {
              this.jc_page_size = v
          }
         
      }
  },
    current_page: {
      get() {
          const tab = Number(this.tab)
          return tab === 0 ? this.tf_page : this.jc_page
      },
      set(v) {
          const tab = Number(this.tab)
          if (tab === 0) {
              this.tf_page = v
          } else {
              this.jc_page = v
          }
         
      }
  },
    total_proxy() {
      const tab = Number(this.tab)
      let arr = []
      if (tab === 0) { // 
          arr = this.placing_ads_records
      } else {
          arr = this.placing_ads_vas_records
      }
      return arr.length
  },
   
    isTfMax() {
      return this.tfMax !== undefined && this.tab === 0 && this.placing_ads_records && this.placing_ads_records.length >= this.tfMax
    },
    canEdit() {
      if (this.isTfMax) {
        return false
      }
      // 财务永远可以编辑
      if (this.isFinancer) {
        return true
      } 
      if (!this.expenseGroup ||
         !this.expenseGroup.user_flow ||
          !this.expenseGroup.user_flow.user_flow_nodes || 
          !this.expenseGroup.user_flow.user_flow_nodes[0]
          ) {
            return false
      }
     return this.expenseGroup.user_flow.user_flow_nodes[0].flow_node_name === '填写申请'
    },
    // have_data() {
    //   return this.placing_ads_vas_records &&
    //   this.placing_ads_records && (!!this.placing_ads_records.length || !!this.placing_ads_vas_records.length)
    // },
    // placing_ads_records: [],
    // placing_ads_vas_records: [],
    proxy_selected_records() {
      let arr = this.placing_ads_vas_records
      if (this.tab === 0) {
        arr = this.placing_ads_records
      }
      return arr.slice((this.current_page - 1) * this.page_size_proxy, this.current_page * this.page_size_proxy)
    },
    pre_list() {
      return this.tab === 0 ? this.pre_placingadsrecord_list : this.pre_placing_ads_vas_record_list
    },
    selected_fields_proxy() {
      if (this.tab === 0) {
        return this.selected_fields_placingadsrecord
      }
      return this.selected_common_placing_ads_vas_record_fields
    },
    pre_fields_proxy() {
      if (this.tab === 0) {
        return this.pre_fields_placingadsrecord
      }
      return this.pre_placing_ads_vas_record_fields
    },
    // 投放记录
    selected_fields_placingadsrecord() {
      const common_placingadsrecord_fields = this.common_placingadsrecord_fields.map(i => {
        if (i.value === 'xiaoguo') {
          // Effect
          return {
              ...i,
              render:(_, t) => {
                  return <div>
                    <Tooltip value={t} showList={[ 2, 3]}/>
              </div>
              } 
          }
      }
        return i
      })
      let arr = [ 
       
      {
        ...common_placingadsrecord_fields[0],
        renderv:(_, v, target) => {
          if (!this.isCheckSameBill) {
            return <span>{v}</span>
       }
        const key = `${target.kol_id}/${target.payable_price}/${target.publish_at}`
        const show = this.ads_hash[key] > 1
          return <span style={{
            color: show && 'red'
          }}>{v}</span>
        }
      },
      {
        text: '金额',
        align: 'right',
        width: 140,
        value: 'have_paid_amount',
        render:(_, t) => {
          return <NumberField
          field={{
            label: '',
            key: 'have_paid_amount',
            d_digits:2,
            placeholder: '请输入',
            suffix: '元',          
            blur: (e = {}) => {
              if (e.target) {
              this.saveProxy({
                record_id: t.id,
                record_type: 'PlacingAdsRecord',
                id: this.expenseGroup.id,
                have_paid_amount: e.target._value
              })
              }
            } 
          }}
          value={t}
      />
        }
      },
      ...common_placingadsrecord_fields.slice(1)]
      if (!this.canEdit) {
        //arr = arr.slice(1)
        arr = arr.map(item => {
          if (item.value === 'have_paid_amount') {
            return {
              text: '金额',
              width: 140,
              value: 'have_paid_amount',
              type: 'money_field',
            }
          }
          return item
        })
      }
      arr.push({
        text: '操作',
        align: 'center',
        value: 'handle',
        width: 120,
        fixed: 'right',
        render:(_, t) => {
          return <VBtn
              color="error" 
              small
              text
              on={{
            click: () => {
              this.deleteProxy({
                ...t,
                record_type:'PlacingAdsRecord'
              })
            }
          }}>
            <VIcon dark>
              mdi-minus-circle-outline
            </VIcon>
          </VBtn>
        }
      })
      // console.log('selected_fields_placingadsrecord', arr.map(i => i.value))
      return arr
    },
    pre_fields_placingadsrecord() {
      return [ 
        {
        text: '操作',
        align: 'center',
        value: 'handle',
        width: 120,
        fixed: 'right',
        render:(_, t) => {
          return <VBtn color="primary" small on={{
            click: () => {
              const a = {
                record_id: t.id,
                record_type: 'PlacingAdsRecord',
                id: this.expenseGroup.id
              }
              if ([1, 9].includes(this.billType)) {
                a.have_paid_amount = Number(t.payable_price) || Number(t.total_price) - Number(t.paid_price) || 0
               }
              this.saveProxy(a)
            }
          }}>
            关联
          </VBtn>
        }
      }, ...this.common_placingadsrecord_fields]
    },
    // 加成服务
    selected_common_placing_ads_vas_record_fields() {
      let arr = [ 
        {
        text: '操作',
        align: 'center',
        value: 'handle',
        width: 120,
        fixed: 'right',
        render:(_, t) => {
          return <VBtn color="error" small text on={{
            click: () => {
              this.deleteProxy({
                ...t,
                record_type:'PlacingAdsVasRecord'
              })
            }
          }}>
            <VIcon dark>
              mdi-minus-circle-outline
            </VIcon>
          </VBtn>
        }
      },
      this.common_placing_ads_vas_record_fields[0],
   
      {
        text: '金额',
        align: 'right',
        width: 140,
        value: 'have_paid_amount',
        render:(_, t) => {
          return <NumberField
          field={{
            label: '',
            key: 'have_paid_amount',
            d_digits:2,
            placeholder: '请输入',
            suffix: '元',          
            blur: (e = {}) => {
              if (e.target) {
              this.saveProxy({
                record_id: t.id,
                record_type: 'PlacingAdsVasRecord',
                id: this.expenseGroup.id,
                have_paid_amount: e.target._value
              })
              }
            } 
          }}
          value={t}
      />
        }
      }, 
      ...this.common_placing_ads_vas_record_fields.slice(1)]
      if (!this.canEdit) {
        arr = arr.slice(1)
        arr = arr.map(i => {
          if (i.value === 'have_paid_amount') {
            return {
              text: '金额',
             // align: 'right',
              value: 'have_paid_amount',
              type: 'money_field',
              width: 120,
            }
          }
          return i
        })
     
      }
     
      return arr
    },
    pre_placing_ads_vas_record_fields() {
      return [ 
        {
        text: '操作',
        align: 'center',
        value: 'handle',
        width: 120,
        fixed: 'right',
        render:(_, t) => {
          return <VBtn color="primary" small on={{
            click: () => {
              this.saveProxy({
                record_id: t.id,
                record_type: 'PlacingAdsVasRecord',
                id: this.expenseGroup.id,
                have_paid_amount: t.total_price
              })
            }
          }}>
            关联
          </VBtn>
        }
      }, ...this.common_placing_ads_vas_record_fields]
    },
    placing_ads_records_sum() {
      const arr = this.placing_ads_records || []
      if (arr.length === 0) {
          return 0
      }
      let sum = math.eval('0')
      this.placing_ads_records.forEach(i => {
          sum = math.eval(`${i.have_paid_amount || 0}+${sum}`)
      })
      return formattingNumber(sum.toNumber(), 2)  
  },
  },
  watch: {
    show(v) {
      if (!v) {
          this.tf_page = 1
          this.tf_page_size = 10
          this.jc_page = 1
          this.jc_page_size = 10
      }
  }
  },
  methods: {
    init() {
      this.show = true
      this.getSuccessData()
    },
    deleteProxy(params, record_type) {
      this.get_selected_loading = true
      postExpenseGroupDeletePlacingAdsApi({
        id: this.expenseGroup.id,
        record_id: params.id,
        record_type
      }).then(() => {
        this.$Message.success('数据删除成功！')
        this.getSuccessData()
      }).finally(() => {
        this.get_selected_loading = false
      })
    },
    saveProxy(params) {
      this.get_selected_loading = true
      postExpenseGroupSavePlacingAdsApi({
        ...params
      }).then(() => {
        this.$Message.success('数据保存成功！')
        this.getSuccessData()
      }).finally(() => {
        this.get_selected_loading = false
      })
    },
    getSuccessData() {
      this.get_selected_loading = true
      getPlacingAdsListApi({id:this.expenseGroup.id}).then(res => {
        this.placing_ads_records = res.placing_ads_records || []
       
        if (this.isCheckSameBill) {
          this.ads_hash = {}
          this.placing_ads_records.forEach(ads => {
            const key = `${ads.kol_id}/${ads.payable_price}/${ads.publish_at}`
            if (!this.ads_hash[key]) {
              this.ads_hash[key] = 0
            }
            this.ads_hash[key]++
          });
        }
        this.placing_ads_vas_records = res.placing_ads_vas_records || []
        // if (this.placing_ads_records.length) {
        //   this.tab = 0
        // }
        // if (this.placing_ads_vas_records.length) {
        //   this.tab = 1
        // }
      }).finally(() => {
        this.get_selected_loading = false
      })
    },
    search(type) {
      this.get_pre_loading = true
      let relate_type = undefined
      switch (this.billType) {
        case 1:
          relate_type = 'payment_bill'
          break;
          case 9:
          relate_type = 'account_bill'
            break;
        default:
          break;
      }
      const api = type === 0 ? getPlacingAdsRecordSelectSearchApi : getPlacingAdsVasRecordSelectSearchApi
      api({
        ...this.params,
        query_all: this.isFinancer,
        relate_type,
      }).then(res => {
       if (type === 0) {
        this.pre_placingadsrecord_list = res || []
       } else {
        this.pre_placing_ads_vas_record_list = res || []
       }
      }).finally(() => {
        this.get_pre_loading = false
      })
    }
  },
  render() {
    return <VModal 
              dynamicHeight
              heightRate={0.9}
              v-model={this.show}
              cancelText=""
              successColor=""
              title="关联投放计划/加成服务"
              width={900}
              ok-text="关闭"
              on={{
                ok: () => {
                    this.show = false
                },
            }}
              >
                <VTabs
                
                 v-model={this.tab}>
                    <VTab >
                       投放记录
                    </VTab>
                    <VTab >
                      加成服务
                    </VTab>
                </VTabs>
                <div>
                {this.tab === 0 && <div style="margin:10px 0">{this.havePaidAmountitleTotal}{this.placing_ads_records_sum}</div>}
                  <VTable 
                    loading={this.get_selected_loading}
                    headers={this.selected_fields_proxy}
                    desserts={this.proxy_selected_records}
                  />
                  {!!this.total_proxy && <VPage
                                current={this.current_page}
                                total={this.total_proxy }
                                page-size={this.page_size_proxy}
                                size-arr={[10, 20, 50]}
                                on={
                                {
                                    changePageSize:(per_page) => {
                                       
                                        this.page_size_proxy = per_page
                                    },
                                    pageChange:(page) => {
                                     
                                        this.current_page = page
                                    }
                                }
                                }
                            />}
                  {this.isTfMax && <p>最多关联30条投放记录</p>}
                 { this.canEdit && <VTextField 
                    style="margin:10px"
                    small
                    v-model={this.params.search}
                    plac
                    outlined
                    append-icon="mdi-magnify" 
                    placeholder="请输入..."
                    on={{ 'click:append':  () => this.search(this.tab), }}
                  />} 
                   { this.canEdit && <VTable 
                    loading={this.get_pre_loading}
                    headers={this.pre_fields_proxy}
                    desserts={this.pre_list}
                  
                  />}
                </div>
      </VModal>
  }
}